
import React, { useEffect } from 'react';
import styles from './Modals.css';

export const ModalsWrapper = ({ children }) => {

  useEffect(() => {
    document.body.classList.add('noscroll');
    return () => document.body.classList.remove('noscroll');
  }, []);

  return(
    <>
      <div className={styles['blocker-overlay']}></div>
      <div className={styles['blocker-modal']} data-color='bg-text'>
        {children}
      </div>
    </>
  ) ; 
};